import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const SmallTable = styled.table`
  border-collapse: collapse;
  color: ${tokens.text.primary};
  width: 100%;
  * {
    text-align: start;
  }

  tbody tr td {
    font-size: 14px;
    color: ${tokens.text.primary};
    padding: 10px 1.5rem 10px 0;
    border-top: 1px solid ${tokens.border.hairline};
    line-height: 20px;
    white-space: nowrap;
  }

  tbody tr td:last-child {
    padding-right: 0;
    text-align: end;
  }
`

export const SmallThead = styled.thead`
  color: ${tokens.text.secondary};

  th {
    padding: 0 1.5rem 12px 0;
    line-height: 18px;
    font-size: ${tokens.font.label};
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    white-space: nowrap;
  }

  th:last-child {
    padding-right: 0;
    text-align: end;
  }
`
